import { Outlet } from "react-router-dom";
import styled from "styled-components";
import { SP_BREAKPOINT } from "../../constants/app";
import { PRIMARY_LIGHT_GREEN } from "../../constants/color";
import { Logo } from "../atoms/Logo";

type Props = {
  hideLogo?: boolean;
};

export const LoginTemplate: React.FC<Props> = ({ hideLogo }) => {
  return (
    <StyledLoginTemplateContainer>
      {!hideLogo && (
        <StyledLogoContainer>
          <Logo width={230} height={48} />
        </StyledLogoContainer>
      )}

      <Outlet />
    </StyledLoginTemplateContainer>
  );
};

const StyledLoginTemplateContainer = styled.div`
  @media (max-width: ${SP_BREAKPOINT}) {
    padding: 40px 16px;
  }

  width: 100vw;
  min-height: 100vh;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 40px 0;
  background-color: ${PRIMARY_LIGHT_GREEN};
`;

const StyledLogoContainer = styled.div`
  @media (max-width: ${SP_BREAKPOINT}) {
    margin-top: 0;
  }
  margin-top: -40px;
  margin-bottom: 40px;
`;
